import script from "./Points.vue?vue&type=script&setup=true&lang=js"
export * from "./Points.vue?vue&type=script&setup=true&lang=js"

import "./Points.vue?vue&type=style&index=0&id=49806581&lang=scss&scoped=true"
import "./Points.vue?vue&type=style&index=1&id=49806581&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49806581"]])

export default __exports__